import axios from "axios";
import {
  SUPPLIER_URL,
  KONNECT_URL,
  GET_STATE_URL,
  GET_CITY_URL,
  SUPPLIER_EXPORT,
  SUPPLIERS_IMPORT_URL,
  PRESIGNED_URL,
  VENDORS_URL,
  PURCHASE_ORDER_PAYMENT,
  SUPPLIER_PURCHASE_ORDER_BY_ID,
  SUPPLIER_PURCHASE_RETURN_ORDER_BY_ID,
  SUPPLIER_LEDGER_CSV_PDF_URL,
  SEND_SUPPLIER_INVOICE_EMAIL_URL,
  BACKGROUND_TASK_STATUS,
  SUPPLIER_BALANCE_ADJUSTMENT_URL,
} from "../../../../../constants/config";
import { PURCHASE_RECEIVE_URL, PURCHASE_ORDER_V2_URL } from "../../../../../constants/config";
import { REPLACE_TO_DEFAULT_QUERY_PARAMS, genericStatusChecker } from "../../../Common/utils";
import { initialFilter } from "../../pages/suppliers/SuppliersUIHelpers";

export function createSupplier(supplier) {
  return axios.post(SUPPLIER_URL, supplier);
}

// Supplier balance adjustment (mirror of the customer balance adjustment CRUD).
export function createSupplierBalanceAdjustment(payload) {
  return axios.post(SUPPLIER_BALANCE_ADJUSTMENT_URL, payload);
}

export function getSupplierBalanceAdjustment(id) {
  return axios.get(`${SUPPLIER_BALANCE_ADJUSTMENT_URL}/${id}`);
}

export function voidSupplierBalanceAdjustment(id) {
  return axios.post(`${SUPPLIER_BALANCE_ADJUSTMENT_URL}/${id}/void`);
}

// READ
export function addPayment(payment) {
  return axios.post(`${PURCHASE_RECEIVE_URL}/pay`, payment);
}

export function getPurchaseReceiptsOfSupplier(queryParams) {
  return axios.get(`${PURCHASE_ORDER_V2_URL}/list`, { params: { statuses: 2, ...queryParams } });
}

// Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// items => filtered/sorted result

export function findSuppliers(queryParams) {
  queryParams = queryParams === undefined ? initialFilter : REPLACE_TO_DEFAULT_QUERY_PARAMS(queryParams, initialFilter);
  return axios.get(
    `${SUPPLIER_URL}/list2?search_key=${queryParams.searchKey ? encodeURIComponent(queryParams.searchKey) : ""}&sort_by=id:desc&page=${
      queryParams.pageNumber
    }&page_size=${queryParams?.pageSize}&konnect_status=${queryParams?.konnectStatus || ""}&portal_access=${queryParams?.portalAccess || ""}`
  );
}

export function findMultipleSuppliersbyId(id) {
  return axios.get(`${SUPPLIER_URL}/list2?supplier_ids=${id}`);
}

export function findOptimizeSuppliers(params) {
  return axios.get(`${SUPPLIER_URL}/list2`, { params });
}

export function findVendors(params) {
  return axios.get(`${SUPPLIER_URL}/list2`, { params });
}

export function findSupplierBYId(id) {
  return axios.get(`${SUPPLIER_URL}/${id}`);
}

export function findVendersBYId(id) {
  return axios.get(`${VENDORS_URL}/${id}`);
}

export function getKonnectMapping(supplierId) {
  return axios.get(`${SUPPLIER_URL}/${supplierId}/konnect`);
}

export function findKonnects(params) {
  return axios.get(`${KONNECT_URL}/list`, { params });
}

export function testKonnectConnection(supplierId, data) {
  return axios.post(`${SUPPLIER_URL}/${supplierId}/konnect`, { ...data, is_dry_run: true });
}

export function registerKonnectConnection(supplierId, data) {
  return axios.post(`${SUPPLIER_URL}/${supplierId}/konnect`, data);
}

export function updateKonnectConnection(supplierId, data) {
  return axios.patch(`${SUPPLIER_URL}/${supplierId}/konnect`, data);
}

export function deleteKonnectConnection(supplierId) {
  return axios.delete(`${SUPPLIER_URL}/${supplierId}/konnect`);
}

export function loginToEcom(mappingId) {
  return axios.post(`${KONNECT_URL}/${mappingId}/login-to-ecom`);
}

export function findPulledInvoices(params) {
  return axios.get(`${KONNECT_URL}/pulled-invoices`, { params });
}

function checkKonnectTaskStatus(id) {
  return axios.get(`${BACKGROUND_TASK_STATUS}/${id}`);
}

export function convertKonnectToPO(mappingId, saleOrderId) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${KONNECT_URL}/${mappingId}/${saleOrderId}`)
      .then((response) => {
        if (response?.data?.id) {
          localStorage.setItem("konnectToPOTaskId", response.data.id);
          genericStatusChecker("konnectToPOTaskId", checkKonnectTaskStatus, reject, resolve);
        }
      })
      .catch(reject);
  });
}

export function saveKonnectProductMap(mappingId, mappings) {
  // Bulk-upsert konnect_product_map rows.
  // Response: { saved: [{mapping_id, remote_product_id, remote_unit}], errors: [...] }
  return axios.post(`${KONNECT_URL}/${mappingId}/product-map`, { mappings });
}

// UPDATE => PUT: update the procuct on the server
export function updateSupplier(supplier) {
  return axios.put(`${SUPPLIER_URL}/${supplier.id}`, supplier);
}

export function getCities(params) {
  return axios.get(`${GET_CITY_URL}`, { params });
}

export function checkExportApiStatus(ids) {
  return axios.post(`${SUPPLIER_EXPORT}`, { supplier_ids: ids });
}

export function getStates(params) {
  return axios.get(`${GET_STATE_URL}`, { params });
}

export function supplierBulkCreate(s3_key) {
  return axios.post(`${SUPPLIERS_IMPORT_URL}/import`, { s3_key });
}

export function getPresignedUrl(key) {
  key = key?.replaceAll(" ", "-");
  return axios.post(PRESIGNED_URL, [{ key: key }]);
}

export function uploadFileToCloud(payload) {
  return fetch(payload.url, {
    method: "PUT",
    body: payload.file,
  });
}

export function findSupplierOptimized(params) {
  return axios.get(`${SUPPLIERS_IMPORT_URL}/${params}`);
}

export function getSupplierSummary(supplierId) {
  return axios.get(`${SUPPLIERS_IMPORT_URL}/${supplierId}/summary`);
}

export function getLedgerInfo(params) {
  return axios.get(`${PURCHASE_ORDER_V2_URL}/list`, { params });
}

export function customerLedgerPayment(params) {
  return axios.get(`${PURCHASE_ORDER_PAYMENT}/list`, { params });
}

export function getPaymentById(id) {
  return axios.get(`${PURCHASE_ORDER_PAYMENT}/${id}`);
}

// Get Single Purchase Order by Id to display details on Modal
export function getSupplierPurchaseOrderById(id) {
  return axios.get(`${SUPPLIER_PURCHASE_ORDER_BY_ID}/${id}`);
}

// Get Single Purchase return Order by Id to display details on Modal
export function getSupplierPurchaseReturnOrderById(id) {
  return axios.get(`${SUPPLIER_PURCHASE_RETURN_ORDER_BY_ID}/${id}`);
}

// void supplier payment
export function voidSupplierPayment(id) {
  return axios.put(`${PURCHASE_ORDER_PAYMENT}/${id}/void`);
}

// Supplier Ledger Export
export function printSupplierLedgerPdf(params) {
  return axios.get(`${SUPPLIER_LEDGER_CSV_PDF_URL}/ledger-pdf`, { params });
}

export function printSupplierLedgerCsv(params) {
  return axios.get(`${SUPPLIER_LEDGER_CSV_PDF_URL}/ledger-csv`, { params });
}

export function sendSupplierInvoiceEmail(payload) {
  return axios.post(`${SEND_SUPPLIER_INVOICE_EMAIL_URL}`, payload);
}
